import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { BsXCircle, BsPlusCircle, BsSave, BsClipboard } from 'react-icons/bs'
import TmsHeader from '../TmsComponents/TmsHeader'
import TmsSidebar from '../TmsComponents/TmsSidebar'

const URL = 'https://kaasbackend.vetrinahealthcare.com/'

const CreateAssessment = () => {
  const [name, setName] = useState('')
  const [training, setTraining] = useState('')
  const [trainings, setTrainings] = useState([])
  const [questions, setQuestions] = useState([
    {
      id: '1',
      text: '',
      options: [{ id: '1', text: '' }],
      selectedOption: null,
    },
  ])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [assessmentLink, setAssessmentLink] = useState(null) // New state for storing the link

  useEffect(() => {
    const fetchTrainings = async () => {
      const token = localStorage.getItem('jwttoken')
      setLoading(true)
      try {
        const { data } = await axios.get(`${URL}tms/training/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        setTrainings(data.trainings)
        setError(null)
      } catch (error) {
        console.error('Error fetching training data:', error)
        setError('Failed to load training options. Please try again later.')
      } finally {
        setLoading(false)
      }
    }
    fetchTrainings()
  }, [])

  const handleChange = (setter) => (e) => setter(e.target.value)

  const addOption = (questionId) => {
    setQuestions((prev) =>
      prev.map((q) =>
        q.id === questionId
          ? {
              ...q,
              options: [...q.options, { id: Date.now().toString(), text: '' }],
            }
          : q
      )
    )
  }

  const removeOption = (questionId, optionId) => {
    setQuestions((prev) =>
      prev.map((q) =>
        q.id === questionId
          ? { ...q, options: q.options.filter((o) => o.id !== optionId) }
          : q
      )
    )
  }

  const addQuestion = () => {
    setQuestions((prev) => [
      ...prev,
      {
        id: Date.now().toString(),
        text: '',
        options: [{ id: Date.now().toString(), text: '' }],
        selectedOption: null,
      },
    ])
  }

  const removeQuestion = (questionId) => {
    setQuestions((prev) => prev.filter((q) => q.id !== questionId))
  }

  const updateQuestion = (id, text) => {
    setQuestions((prev) => prev.map((q) => (q.id === id ? { ...q, text } : q)))
  }

  const updateOption = (questionId, optionId, text) => {
    setQuestions((prev) =>
      prev.map((q) =>
        q.id === questionId
          ? {
              ...q,
              options: q.options.map((o) =>
                o.id === optionId ? { ...o, text } : o
              ),
            }
          : q
      )
    )
  }

  const handleOptionSelect = (questionId, optionId) => {
    setQuestions((prev) =>
      prev.map((q) =>
        q.id === questionId ? { ...q, selectedOption: optionId } : q
      )
    )
  }

  const handleSave = async () => {
    const token = localStorage.getItem('jwttoken')
    const csrfToken = localStorage.getItem('csrftoken')

    const formattedQuestions = questions.map((q) => ({
      question: q.text,
      options: q.options.map((o) => o.text),
      correct: q.options.findIndex((o) => o.id === q.selectedOption),
    }))

    const assessmentData = { name, questions: formattedQuestions }

    try {
      const response = await axios.post(
        `${URL}tms/training/${training}/quizzes/`,
        assessmentData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken,
          },
        }
      )
      console.log('Assessment saved successfully:', response.data)

      // Generate the link for the saved assessment
      setAssessmentLink(response.data.quiz_url)
    } catch (error) {
      console.error('Error saving assessment:', error)
    }
  }

  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(assessmentLink)
    alert('Link copied to clipboard')
  }

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#f0f4f8',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <TmsSidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <TmsHeader />
        <div
          style={{
            padding: '2rem',
            maxWidth: '900px',
            margin: 'auto',
            marginTop: '20px',
            backgroundColor: '#fff',
            borderRadius: '0.75rem',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <h1
            style={{
              fontSize: '2rem',
              fontWeight: '600',
              textAlign: 'center',
              marginBottom: '2rem',
              color: '#333',
            }}
          >
            Create Assessment
          </h1>
          <input
            type='text'
            placeholder='Assessment Name'
            value={name}
            onChange={handleChange(setName)}
            style={{
              width: '100%',
              border: '1px solid #ccc',
              borderRadius: '0.375rem',
              padding: '0.75rem',
              marginBottom: '1.5rem',
            }}
          />
          {loading ? (
            <p>Loading trainings...</p>
          ) : error ? (
            <p style={{ color: 'red' }}>{error}</p>
          ) : (
            <select
              value={training}
              onChange={handleChange(setTraining)}
              style={{
                width: '100%',
                border: '1px solid #ccc',
                borderRadius: '0.375rem',
                padding: '0.75rem',
                marginBottom: '1.5rem',
              }}
            >
              <option value=''>Select Training</option>
              {trainings.map((train) => (
                <option key={train.training_id} value={train.training_id}>
                  {train.title}
                </option>
              ))}
            </select>
          )}
          {questions.map((question, questionIndex) => (
            <div
              key={question.id}
              style={{
                backgroundColor: '#f9fafb',
                padding: '1rem',
                borderRadius: '0.5rem',
                marginBottom: '1.5rem',
                border: '1px solid #e2e8f0',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '0.75rem',
                }}
              >
                <input
                  type='text'
                  placeholder={`Question ${questionIndex + 1}`}
                  value={question.text}
                  onChange={(e) => updateQuestion(question.id, e.target.value)}
                  style={{
                    flex: 1,
                    border: '1px solid #ccc',
                    borderRadius: '0.375rem',
                    padding: '0.75rem',
                    marginRight: '0.75rem',
                  }}
                />
                <button
                  onClick={() => removeQuestion(question.id)}
                  style={{
                    color: '#e53e3e',
                    cursor: 'pointer',
                    border: '0px',
                    background: 'transparent',
                  }}
                  aria-label='Remove question'
                >
                  <BsXCircle size={24} />
                </button>
              </div>
              {question.options.map((option, optionIndex) => (
                <div
                  key={option.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '0.5rem',
                  }}
                >
                  <input
                    type='radio'
                    name={`question-${question.id}`}
                    checked={question.selectedOption === option.id}
                    onChange={() => handleOptionSelect(question.id, option.id)}
                    style={{ marginRight: '0.5rem' }}
                  />
                  <input
                    type='text'
                    placeholder={`Option ${optionIndex + 1}`}
                    value={option.text}
                    onChange={(e) =>
                      updateOption(question.id, option.id, e.target.value)
                    }
                    style={{
                      flex: 1,
                      border: '1px solid #ccc',
                      borderRadius: '0.375rem',
                      padding: '0.75rem',
                      marginRight: '0.75rem',
                    }}
                  />
                  <button
                    onClick={() => removeOption(question.id, option.id)}
                    style={{
                      color: '#e53e3e',
                      cursor: 'pointer',
                      border: '0px',
                      background: 'transparent',
                    }}
                    aria-label='Remove option'
                  >
                    <BsXCircle size={24} />
                  </button>
                </div>
              ))}
              <button
                onClick={() => addOption(question.id)}
                style={{
                  color: '#3182ce',
                  cursor: 'pointer',
                  border: '0px',
                  background: 'transparent',
                }}
                aria-label='Add option'
              >
                <BsPlusCircle size={24} style={{ marginRight: '0.5rem' }} />
                Add Option
              </button>
            </div>
          ))}
          <button
            onClick={addQuestion}
            style={{
              color: '#3182ce',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              border: '0px',
              background: 'transparent',
            }}
            aria-label='Add question'
          >
            <BsPlusCircle size={24} style={{ marginRight: '0.5rem' }} />
            Add Question
          </button>
          <button
            onClick={handleSave}
            style={{
              width: '100%',
              padding: '0.75rem',
              backgroundColor: '#38a169',
              color: '#fff',
              fontWeight: '600',
              borderRadius: '0.375rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '1.5rem',
            }}
            aria-label='Save assessment'
          >
            <BsSave size={24} style={{ marginRight: '0.5rem' }} />
            Save Assessment
          </button>

          {assessmentLink && (
            <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
              <p>Assessment Link:</p>
              <p>
                <input
                  type='text'
                  value={assessmentLink}
                  readOnly
                  style={{
                    width: '80%',
                    padding: '0.5rem',
                    border: '1px solid #ccc',
                    borderRadius: '0.375rem',
                  }}
                />
                <button
                  onClick={copyLinkToClipboard}
                  style={{
                    color: '#3182ce',
                    cursor: 'pointer',
                    border: '0px',
                    background: 'transparent',
                    marginLeft: '0.5rem',
                  }}
                  aria-label='Copy link'
                >
                  <BsClipboard size={24} />
                </button>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CreateAssessment
